var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { elevation: "0" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("popup-move-snapshot-to-folder", {
        ref: "popup-move-snapshot-to-folder",
      }),
      _c("popup-edit-snapshot-folder", { ref: "popup-edit-snapshot-folder" }),
      _c("popup-edit-string", { ref: "popup-edit-string" }),
      _c("popup-upload-snapshots", { ref: "popup-upload-snapshots" }),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card",
            {
              staticClass: "mb-2",
              attrs: { elevation: "0", outlined: "", width: "100%" },
            },
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 white--text",
                      attrs: { color: "orange", elevation: "0", outlined: "" },
                    },
                    [_vm._v("Snapshots: " + _vm._s(_vm.snapshotsCount))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        disabled: !_vm.ifCanImportSave(),
                        loading: _vm.importing,
                        elevation: "0",
                        color: "blue",
                      },
                      on: { click: _vm.onPressImportSave },
                    },
                    [
                      _vm._v(" Import Zip with shapshots "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-2", attrs: { size: "20" } },
                        [_vm._v("mdi-database-import-outline")]
                      ),
                    ],
                    1
                  ),
                  _c("input", {
                    ref: "uploader",
                    staticClass: "d-none",
                    attrs: { type: "file", accept: ".zip" },
                    on: { change: _vm.onFileChanged },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card",
            { attrs: { outlined: "", elevation: "0", width: "100%" } },
            [
              _c(
                "v-card-actions",
                [
                  _c("v-text-field", {
                    staticStyle: { "margin-bottom": "-30px" },
                    attrs: {
                      label: "Search",
                      placeholder: "Enter keyword to searchs in names",
                      outlined: "",
                      clearable: "",
                      "append-icon": "mdi-magnify",
                    },
                    on: {
                      "click:append": _vm.searchSnapshot,
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchSnapshot.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.tempFindData,
                      callback: function ($$v) {
                        _vm.tempFindData = $$v
                      },
                      expression: "tempFindData",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0 mt-2" },
        [
          _c(
            "v-card",
            { attrs: { elevation: "0", width: "100%" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-slide-group",
                    { staticClass: "pa-0", attrs: { "show-arrows": "" } },
                    _vm._l(_vm.folders, function (folder) {
                      return _c(
                        "v-slide-item",
                        { key: folder.fid },
                        [
                          folder.fid != "add"
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    outlined: "",
                                    elevation: "0",
                                    height: "60",
                                    width: "120",
                                  },
                                },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "ma-0 pa-0" },
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-card",
                                                {
                                                  attrs: {
                                                    elevation: "0",
                                                    height: "22px",
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "0.8em",
                                                        "margin-left": "10px",
                                                        "margin-top": "3px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(folder.name)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-card",
                                                {
                                                  attrs: {
                                                    elevation: "0",
                                                    height: "35px",
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-card-actions",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            color: "black",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onPressCheckFolder(
                                                                folder
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "22",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.isSelected(
                                                                      folder
                                                                    )
                                                                      ? "mdi-checkbox-marked"
                                                                      : "mdi-checkbox-blank-outline"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("v-spacer"),
                                                      folder.fid != "all"
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                color: "green",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onPressEditFolder(
                                                                      folder
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    size: "22",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-pencil"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    elevation: "0",
                                    height: "60",
                                    width: "60",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        elevation: "0",
                                        color: "green",
                                        width: "60px",
                                        height: "60px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addFolder()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "white" } },
                                        [_vm._v("mdi-plus")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0 mt-2" },
        [
          _c(
            "v-card",
            { attrs: { outlined: "", width: "100%" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c("v-data-table", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "fixed-header": "",
                      items: _vm.snapshots,
                      headers: _vm.headers,
                      "hide-default-footer": "",
                      "sort-by": ["created"],
                      "sort-desc": true,
                      "disable-pagination": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.created",
                        fn: function ({ item }) {
                          return [
                            _c("v-card-text", [
                              _vm._v(
                                _vm._s(_vm._f("formatDateISO")(item.created))
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.name",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-1",
                                attrs: { outlined: "", color: "green" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPressEditName(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.name || "no name") + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", "max-width": "50%" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    icon: "",
                                                    color: "orange",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPressInfo(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "22" } },
                                                [_vm._v("mdi-information")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.info != undefined &&
                                        item.info.length != 0
                                        ? item.info
                                        : "no info"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    icon: "",
                                                    color: "blue",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPressMoveToFolder(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "22" } },
                                                [_vm._v("mdi-folder-move")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.info != undefined &&
                                        item.info.length != 0
                                        ? item.info
                                        : "no info"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    loading:
                                                      _vm.deleting == item.id,
                                                    icon: "",
                                                    color: "red",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPressDelete(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "22" } },
                                                [_vm._v("mdi-delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Delete snapshot")])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }